import ApiService from "@/services/api.service";

const ContactBookService = {
  loadChunkCount: async function () {
    return ApiService.post(`/ApiFetchChunkCount`, {
      body: {},
      command: "FetchChunkCount",
    });
  },
  loadContacts: async function (userContactBookSize: number) {
    return ApiService.post(`/ApiUserContactBook`, {
      body: { chunk: userContactBookSize },
      command: "UserContactBook",
    });
  },
  loadGroups: async function (groupContactBookSize: number) {
    return ApiService.post(`/ApiGroupContactBook`, {
      body: { chunk: groupContactBookSize },
      command: "GroupContactBook",
    });
  },
};

export default ContactBookService;
